import { Button, Header } from '@wework/dieter-ui'

import React, { useEffect } from 'react'

import SelectedSpaces from '../BulkEdit/SelectedSpaces'
import { SidebarCollapseIcon, SidebarExtendIcon } from '../Icons'

export default function BulkActionsDrawer({
  spaces,
  onClose,
  onHoldHandler,
  spaceSetter,
  setIsExpanded,
  isExpanded,
}) {
  useEffect(() => {
    return () => {
      setIsExpanded(false)
    }
  }, [setIsExpanded])

  if (spaces.length === 0) return <></>

  return (
    <>
      <div
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 24,
        }}
      >
        <Header as="h3" style={{ margin: 0 }}>
          Multi-Select
        </Header>
        <div style={{ display: 'flex' }}>
          <Button
            basic
            onClick={() => setIsExpanded(!isExpanded)}
            icon={
              isExpanded ? (
                <SidebarCollapseIcon width={12} height={12} />
              ) : (
                <SidebarExtendIcon width={12} height={12} />
              )
            }
            style={{ left: 'auto' }}
          />
          <Button
            basic
            onClick={() => {
              setIsExpanded(false)
              onClose()
            }}
            icon="close"
            style={{ left: 'auto' }}
          />
        </div>
      </div>

      <SelectedSpaces
        spaces={spaces}
        onHoldHandler={onHoldHandler}
        spaceSetter={spaceSetter}
        onShrink={() => setIsExpanded(false)}
      />
    </>
  )
}
